/**
 * Created by Claude on 26.01.2026
 *
 * Arkadium SDK Authorization/Social integration
 * https://arkadiumsdk.z19.web.core.windows.net/docs/features/auth/
 */

const ArkadiumSocial = function () {
    Social.call(this, connector.ARKADIUM, {
        sdk: SdkManager.SDK_ARKADIUM
    });

    this.connectListeners = connector.utils.once(() => this._connectListeners());

    this.user = undefined;
};

ArkadiumSocial.prototype = Object.create(Social.prototype);
ArkadiumSocial.prototype.constructor = ArkadiumSocial;

ArkadiumSocial.prototype._connect = function (callback) {
    delete this.authStatusChanged;

    this.connectListeners();

    this.initUserProfile((code) => {
        if (this.authStatusChanged) {
            this._connect(callback);
            return;
        }
        
        callback(code === connector.CODE_SUCCEED ? connector.STATUS_CONNECTED : connector.STATUS_DISCONNECTED);
    });
};

ArkadiumSocial.prototype._connectListeners = function () {
    ArkadiumSDK.auth.onAuthStatusChange((isAuthorized) => {
        console.log(`social onAuthStatusChange ${isAuthorized}`);

        if (this.onAuthStatusChangeListener) {
            this.onAuthStatusChangeListener();
            delete this.onAuthStatusChangeListener;
            return;
        }

        if (!this.isConnected()) {
            this.authStatusChanged = true;
            this.connect();
            return;
        }

        if (!isAuthorized && this.isLoggedIn()) {
            this.onLogout();
            return;
        }

        this.initUserProfile(() => {
            if (this.isLoggedIn()) {
                this.onLogin();
            } else if (!connector.platform.withTmpID() && !connector.platform.withDeviceID()) {
                this.onLogout();
            }
        });
    });

    ArkadiumSDK.auth.onOpenAuthForm((isOpened) => {
        console.log(`social onOpenAuthForm ${isOpened}`);

        if (!isOpened && this.onAuthStatusChangeListener) {
            this.onAuthStatusChangeListener();
            delete this.onAuthStatusChangeListener;
        }
    });
};

ArkadiumSocial.prototype.onLogout = function () {
    delete this.user;
    this.bus.trigger("logout");
};

ArkadiumSocial.prototype.initUserProfile = function (callback) {
    ArkadiumSDK.auth.isUserAuthorized()
        .then((isAuthorized) => {
            console.log(`social isAuthorized ${isAuthorized}`);

            if (!isAuthorized) {
                delete this.user;
            } else {
                return ArkadiumSDK.auth.getUserProfile();
            }
        })
        .then((userProfile) => {
            console.log("social user profile", userProfile);
            if (userProfile) {
                this.user = ArkadiumSocial.formatUserProfile(userProfile);
            }
            callback(connector.CODE_SUCCEED);
        })
        .catch((e) => {
            console.log("social get user profile error", e);
            callback(connector.CODE_FAILED);
        });
};

ArkadiumSocial.prototype.logout = function () {
    delete this.user;
};

ArkadiumSocial.prototype.isLoggedIn = function () {
    return this.user !== undefined;
};

ArkadiumSocial.prototype._getUserID = function () {
    return this.user && this.user.id;
};

ArkadiumSocial.prototype._login = function (callback) {
    callback = connector.utils.once(callback);

    ArkadiumSDK.auth.openAuthForm().then(() => {
        console.log("social open auth form success");

        const onAuthStatusChangeListener = this.onAuthStatusChangeListener = () => this.initUserProfile(callback);

        this.setNotifyActiveListener(connector.utils.accumulate(1000, () => {
            if (onAuthStatusChangeListener === this.onAuthStatusChangeListener) {
                delete this.onAuthStatusChangeListener;
            }
            callback(connector.CODE_FAILED);
        }));
    }).catch((e) => {
        console.log("social open auth form error", e);
        callback(connector.CODE_FAILED);
    });
};

ArkadiumSocial.prototype.getAccessToken = function () {
    return "arkadium";
};

ArkadiumSocial.prototype._aboutMe = function (callback) {
    if (this.user) {
        callback(connector.CODE_SUCCEED, this.user);
    } else {
        callback(connector.CODE_FAILED);
    }
};

ArkadiumSocial.formatUserProfile = function (userProfile) {
    return {
        id: userProfile.uid,
        name: userProfile.username,
        avatar: userProfile.avatar && (userProfile.avatar.webp || userProfile.avatar.png)
    };
};
